import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromMedia from './+state/media/media.reducer';
import { MediaEffects } from './+state/media/media.effects';
import { MediaStateService } from './media-state.service';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(fromMedia.MEDIA_FEATURE_KEY, fromMedia.reducer),
    EffectsModule.forFeature([MediaEffects]),
  ],
  providers: [MediaStateService],
})
export class ShaMediaModule {}
